/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dropdownItemOfintSchema } from './dropdownItemOfintSchema.ts';
import { z } from 'zod';

export const clientDtoSchema = z.object({
  id: z.coerce.number().int().nullable().nullish(),
  name: z.coerce.string().min(1).max(500),
  enabled: z.boolean(),
  canHaveUnconfirmedProjects: z.boolean().nullable().nullish(),
  societa: z.array(z.lazy(() => dropdownItemOfintSchema)),
});
